import React, { useState, useCallback } from 'react';

function currentTheme() {
  return document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
}

export function ThemeToggle() {
  const [theme, setTheme] = useState(currentTheme);

  const toggle = useCallback(() => {
    const root = document.documentElement;
    const next = theme === 'light' ? 'dark' : 'light';
    // Transient class enables a one-shot cross-fade (CSS gates it on reduced-motion).
    root.classList.add('theme-transition');
    window.setTimeout(() => root.classList.remove('theme-transition'), 200);
    if (next === 'light') root.setAttribute('data-theme', 'light');
    else root.removeAttribute('data-theme');
    try { localStorage.setItem('theme', next); } catch (e) {}
    setTheme(next);
  }, [theme]);

  const goingTo = theme === 'light' ? 'dark' : 'light';
  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      aria-label={`Switch to ${goingTo} theme`}
      title={`Switch to ${goingTo} theme`}
    >
      <span aria-hidden="true">{theme === 'light' ? '☀' : '🌙'}</span>
    </button>
  );
}
